<template>
  <div>
    <header class="d-sm-flex justify-content-between align-items-center">
      <h1>Vehículos</h1>
      <b-button :to="{name: 'VehicleNew'}" variant="outline-primary">Nuevo Vehículo</b-button>
    </header>
    <hr>
    <template v-if="isGetVehiclesLoading">
      <div class="text-center">
        <p class="lead">Loading...</p>
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </template>
    <template v-else>
      <template v-if="isVehiclesListEmpty">
        <p class="lead">De momento no hay vehiculos...</p>
      </template>
      <template v-else>
        <b-table
          striped
          borderless
          hover
          sort-by="createdAt"
          :sort-desc="true"
          :items="vehiclesFormatted"
          :fields="tableFields"
          responsive="sm"
          @row-clicked="rowClicked">
          <template slot="status" slot-scope="data">
            <b-badge :variant="data.item.statusClass">{{ data.value }}</b-badge>
          </template>
        </b-table>
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { dateMixin } from '@/mixins/dateMixin'

export default {
  name: 'Vehicles',
  mixins: [dateMixin],
  created () {
    this.loadVehicles()
  },
  data () {
    return {
      isGetVehiclesLoading: true,
      isVehiclesListEmpty: null,
      vehicles: [],
      tableFields: [
        {
          key: 'brand',
          label: 'Marca',
          sortable: true
        },
        {
          key: 'model',
          label: 'Modelo',
          sortable: true
        },
        {
          key: 'carPlate',
          label: 'Matrícula'
        },
        {
          key: 'status',
          label: 'Estado',
          sortable: true
        },
        {
          key: 'createdAt',
          label: 'F. creación',
          sortable: true
        }
      ]
    }
  },
  computed: {
    vehiclesFormatted () {
      return this.vehicles.map(i => {
        i.createdAt = this.dateDDMMYYYY(i.createdAt)
        i.status = i.isActive ? 'Activo' : 'Inactivo'
        i.statusClass = this.setStatusVariant(i.isActive)
        return i
      })
    }
  },
  methods: {
    ...mapActions([
      'getVehicles'
    ]),
    loadVehicles () {
      this.getVehicles()
        .then((res) => {
          this.isGetVehiclesLoading = false
          if (res.empty) {
            this.isVehiclesListEmpty = true
            return false
          }
          res.forEach(doc => {
            console.log(doc.data())
            this.vehicles.push({ id: doc.id, ...doc.data() })
          })
        })
        .catch((err) => {
          console.debug('getVehicles')
          console.log(err)
        })
    },
    rowClicked (item, index, ev) {
      this.$router.push({ name: 'VehicleDetail', params: { vehicleId: item.id } })
    },
    setStatusVariant (val) {
      return val === true ? 'primary' : 'secondary'
    }
  }
}
</script>
